import { useNavigate } from "react-router-dom";

import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import { CustomerSupportVulnerabilityCircumstanceMedicalEquipmentInput } from "../../../generated/customer/schema.graphql";

type MedicalQuestionRecord = Record<
  keyof CustomerSupportVulnerabilityCircumstanceMedicalEquipmentInput,
  string
>;

type MedicalQuestion = Omit<MedicalQuestionRecord, "medicineRefrigeration">;

export const medicalQuestions: MedicalQuestion = {
  nebuliserOrApnoeaMonitor: "Nebuliser and/or apnoea monitor",
  heartOrLungOrVentilatorEquipment: "Heart, lung & ventilator equipment",
  dialysisOrFeedingPumpOrAutomatedMedication:
    "Dialysis, feeding pump & automated medication",
  oxygenConcentrator: "Oxygen concentrator",
  stairLiftOrHoistOrElectricBed: "Stair lift / hoist / electric bed",
  medicallyDependantShowering: "Medically dependant showering or bathing",
};

const MedicalEquipmentDetail: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();
  const navigate = useNavigate();

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      medicalEquipmentDetail: newAnswers,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.MiscellaneousDetail}`);
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={medicalQuestions}
      values={answers.medicalEquipmentDetail}
      onContinue={onContinue}
      step={questionContent.medicalEquipmentDetail.step}
      title={questionContent.medicalEquipmentDetail.title}
      subTitle={questionContent.medicalEquipmentDetail.subTitle}
      whyWeWantTexts={questionContent.medicalEquipment.whyWeWantTextsCustomer}
      requireAnswer
    />
  );
};

export default MedicalEquipmentDetail;
